import { ViewManager } from "@/manager/ViewManager";
import * as THREE from "three";
import { BaseDimemsion } from "./BaseDimension";
import { DbLine } from "@/core/DbLine";
import { DbLayer } from "@/core/DbLayer";
import { ModelManager } from "@/CadEngine";
import { generateUUID } from "three/src/math/MathUtils";
import { CommonColor } from "@/core/Parameters";

/**
 * 圆心辅助锚点
 */
class CircleAnchorPointAuxs extends BaseDimemsion {
  private m_line: THREE.LineSegments | undefined;
  private m_layer: DbLayer;
  private m_model: ModelManager;
  constructor(view: ViewManager, root: THREE.Object3D) {
    super(view, root);
    this.m_root = root;
    this.m_layer = {
      Name: "CircleAnchorPointAuxs",
      Id: "CircleAnchorPointAuxs",
      Color: CommonColor.Black,
      ColorIndex: 0,
      Enabled: true,
      LineCount: undefined,
      MeshCount: undefined,
      Objects: [],
      Visible: true,
      ObjectColors: [],
    };
    this.m_model = view.m_context.ModelManager;
    this.m_model.addLayer(this.m_layer);
  }

  public SetPoint(points: THREE.Vector3[], scale: number) {
    let filterPoints: THREE.Vector3[] = [];
    for (let i = 0; i < points.length; i++) {
      let isCloud = false;
      for (let j = 0; j < filterPoints.length; j++) {
        if (filterPoints[j].equals(points[i])) {
          isCloud = true;
          break;
        }
      }
      if (!isCloud) {
        filterPoints.push(points[i]);
      }
    }
    let path: number[] = [];
    filterPoints.forEach((point) => {
      path.push(
        -5 * scale + point.x,
        point.y,
        0,
        5 * scale + point.x,
        point.y,
        0
      );
      path.push(
        point.x,
        5 * scale + point.y,
        0,
        point.x,
        -5 * scale + point.y,
        0
      );
    });

    if (!this.m_line) {
      let geo = new THREE.BufferGeometry();
      geo.setAttribute(
        "position",
        new THREE.BufferAttribute(new Float32Array(path), 3)
      );
      this.m_line = new THREE.LineSegments(
        geo,
        new THREE.LineBasicMaterial({ color: CommonColor.Green })
      );
      this.m_line.frustumCulled = false;
      this.m_root.add(this.m_line);
    } else {
      this.m_line.geometry.setAttribute(
        "position",
        new THREE.BufferAttribute(new Float32Array(path), 3)
      );
    }

    let key = `${this.m_layer.Id}_${this.m_layer.Color}`;
    let lines: DbLine[] = this.m_model.Lines[key]?.lines ?? [];

    // console.log("filterPoints", filterPoints);
    if (filterPoints.length == 0) {
      if (this.m_model.Lines[key]) {
        let lastObj = this.m_model.LayerTable[this.m_layer.Id].Objects.pop();
        this.m_model.Model.remove(lastObj!);
        this.m_model.Lines[key].lines = [];
        this.m_model.Model.remove(this.m_model.Lines[key].model!);
        delete this.m_model.Lines[key];
      }
      return;
    }
    for (let i = 0; i < filterPoints.length; i++) {
      let isInclude = false;
      lines.forEach((line) => {
        if (line.sphere) {
          if (line.sphere.center.equals(filterPoints[i])) {
            isInclude = true;
          }
        }
      });
      if (isInclude) continue;
      let p: number[] = [];
      let item = filterPoints[i];
      p.push(item.x, item.y, item.z);
      p.push(item.x, item.y, item.z);
      let line = new DbLine({
        id: generateUUID(),
        layerId: this.m_layer.Id,
        blockId: "",
        points: new Float32Array(p),
        indexes: new Int32Array([0, 1]),
        color: this.m_layer.Color,
      });
      let sphere = new THREE.Sphere(item, 1);
      let maxInfinity = new THREE.Vector3(item.x - 0.5, item.y + 0.5, 0);
      let minInfinity = new THREE.Vector3(item.x + 0.5, item.y - 0.5, 0);
      let box = new THREE.Box3(minInfinity, maxInfinity);
      line.sphere = sphere;
      line.box = box;
      lines.push(line);
    }

    if (this.m_model.Lines[key]) {
      let lastObj = this.m_model.LayerTable[this.m_layer.Id].Objects.pop();
      this.m_model.Model.remove(lastObj!);
      let model = this.m_model.addLinesToModel(
        this.m_layer.Id,
        this.m_layer.Color!,
        lines,
        true
      );
      model.visible = false;
      this.m_model.Lines[key].model = model;
    } else {
      let model = this.m_model.addLinesToModel(
        this.m_layer.Id,
        this.m_layer.Color!,
        lines,
        true
      );
      model.visible = false;
      this.m_model.Lines[key] = {
        canEdit: true,
        lines,
        model,
      };
    }
  }

  public dispose() {
    if (this.m_line) {
      this.m_root.remove(this.m_line);
      this.m_line.geometry.dispose();
    }
  }
}

export { CircleAnchorPointAuxs };
